import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { NgxSuneditorComponent } from 'ngx-suneditor';
import { Observable, Observer, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CurrentAffair } from 'src/app/core/interfaces/current-affair';
import { HttpRequestService } from 'src/app/core/services';
import { CkEditorConfigService } from 'src/app/core/services/ck-editor-config.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-add-update-current-affairs',
  templateUrl: './add-update-current-affairs.component.html',
  styleUrls: ['./add-update-current-affairs.component.scss'],
})
export class AddUpdateCurrentAffairsComponent implements OnInit {
  @ViewChildren(NgxSuneditorComponent)
  editors!: QueryList<NgxSuneditorComponent>;
  addUpdateCurrentAffairForm: FormGroup;
  idForUpdate: string;
  buttonLoading = false;
  tagLoading = false;
  imageLoading = false;
  checkAddPermission = false;
  checkUpdatePermission = false;
  mediaBaseUrl = environment.mediaBaseUrl;
  mediaUploadUrl = environment.apiBaseUrl + '/api/media';
  searchExamCategory: Subject<string> = new Subject<string>();
  examCategorySearch: string = '';
  listOfTags: any[] = [];
  name = 'test';
  public editorOptions: any;
  editor: any;
  log: string = '';
  tabIndex: number = 0;
  searchTag: Subject<string> = new Subject<string>();
  tagSearch: string = '';
  pageSize = 10;
  pageIndex = 1;
  totalTagDataCount: number = 0;
  fromReportContent: boolean = false;
  constructor(
    private fb: FormBuilder,
    private httpRequestService: HttpRequestService,
    private notificationService: NzNotificationService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private msg: NzMessageService,
    private ckEditorService: CkEditorConfigService,
  ) {
    this.idForUpdate = this.activatedRoute.snapshot.params.id;
    this.tabIndex = this.activatedRoute.snapshot.queryParams.index;

    const fromParam = this.activatedRoute.snapshot.queryParams['fromReport'];
    this.fromReportContent = fromParam === 'true' || fromParam === true;
    this.addUpdateCurrentAffairForm = this.fb.group({
      title: [null, [Validators.required]],
      titleInHindi: [null],
      shortDescription: [null],
      shortDescriptionInHindi: [null],
      description: [null],
      descriptionInHindi: [null],
      image: [null],
      publishedDate: [null],
      tags: [[]],
      status: [true],
    });
  }
  // on page load functions
  ngOnInit(): void {
    this.editorOptions = this.ckEditorService.editorOptions;
    this.editorOptions.height = '100';
    if (this.idForUpdate) {
      this.getCurrentAffairsById();
    }
    this.searchTag.pipe(debounceTime(1000)).subscribe((success: any) => {
      this.tagSearch = success;
      this.getAllTags();
    });
    this.getAllTags();
  }

  onDescriptionChange(content: any) {
    this.addUpdateCurrentAffairForm.patchValue(
      {
        description: content.content,
      },
      { emitEvent: false },
    );
  }

  onDescriptionHindiChange(content: any) {
    this.addUpdateCurrentAffairForm.patchValue(
      {
        descriptionInHindi: content.content,
      },
      { emitEvent: false },
    );
  }

  onShortDescriptionChange(content: any) {
    this.addUpdateCurrentAffairForm.patchValue(
      {
        shortDescription: content.content,
      },
      { emitEvent: false },
    );
  }

  onShortDescriptionHindiChange(content: any) {
    this.addUpdateCurrentAffairForm.patchValue(
      {
        shortDescriptionInHindi: content.content,
      },
      { emitEvent: false },
    );
  }

  //  send auth in headers //
  customRequestHeaders = () => {
    return { Authorization: `Bearer ${localStorage.getItem('token')}` };
  };
  /* Get single subject details by Id */
  getCurrentAffairsById(): void {
    this.httpRequestService
      .request('get', `current-affairs/${this.idForUpdate}`)
      .subscribe(
        (result: any) => {
          const data: CurrentAffair = result.data;
          this.addUpdateCurrentAffairForm.patchValue({
            title: data.title,
            titleInHindi: data.titleInHindi,
            shortDescription: data.shortDescription,
            shortDescriptionInHindi: data.shortDescriptionInHindi,
            image: data.image,
            publishedDate: data.publishedDate,
            tags: data.tags,
            status: true,
          });
          this.editors.forEach((editor: any) => {
            if (editor.editorID === 'description') {
              editor.setContents(data.description);
            } else if (editor.editorID === 'descriptionInHindi') {
              editor.setContents(data.descriptionInHindi);
            } else if (editor.editorID === 'shortDescription') {
              editor.setContents(data.shortDescription);
            } else if (editor.editorID === 'shortDescriptionInHindi') {
              editor.setContents(data.shortDescriptionInHindi);
            }
          });
        },
        (error: any) => {},
      );
  }
  // onLoadDescriptionInHindi(editorID: string, content: any) {
  //   setTimeout(() => {
  //     const editorInstance = document.querySelector(`${editorID}`)?.contentWindow?.suneditor;
  //     if (editorInstance) {
  //       editorInstance.setContents(content);
  //     }
  //   }, 500);
  // }
  /* Get all Subjects */
  getAllTags(skip = 0): void {
    this.tagLoading = true;
    let params: any;
    params = { skip, limit: this.pageSize };
    if (this.tagSearch) {
      params.search = this.tagSearch;
    }
    this.httpRequestService
      .request('get', 'current-affairs/tags', params)
      .subscribe(
        (result: any) => {
          this.tagLoading = false;
          if (this.tagSearch !== '') {
            this.listOfTags = result.data;
          } else {
            this.listOfTags.push(...result.data);
          }

          this.totalTagDataCount = result.totalCount;
        },
        (err: any) => {
          this.tagLoading = false;
        },
      );
  }
  onSearch(event: any): void {
    this.listOfTags = [];
    this.searchTag.next(event);
  }
  loadMore() {
    // calculate skip
    this.pageIndex = this.pageIndex + 1;
    const skip = this.pageSize * (this.pageIndex - 1);
    if (this.totalTagDataCount !== this.listOfTags.length) {
      this.getAllTags(skip);
    } else {
    }
  }
  get tags(): string[] {
    return this.addUpdateCurrentAffairForm.get('tags')?.value || [];
  }

  isSelected(tag: string): boolean {
    return this.tags.includes(tag);
  }

  removeTag(tag: string): void {
    this.tagLoading = true;
    this.httpRequestService
      .request('put', 'current-affairs/delete-tags', { tag })
      .subscribe(
        () => {
          this.tagLoading = false;
          const updatedTags = this.tags.filter((t) => t !== tag);
          this.addUpdateCurrentAffairForm.get('tags')?.setValue(updatedTags);

          this.listOfTags = this.listOfTags.filter((t) => t.name !== tag);
          this.notificationService.success('', 'Tag deleted successfully');
        },
        () => {
          this.tagLoading = false;
          this.notificationService.error('', 'Failed to delete tag');
        },
      );
  }

  addTag(input: HTMLInputElement): void {
    let tag = input.value;
    const totalTags = this.addUpdateCurrentAffairForm.get('tags')?.value;
    if (totalTags.length >= 3) {
      this.notificationService.error(
        '',
        'You can select maximum 3 tags.if you want to add more tag, please remove selected tag first',
      );
      return;
    }
    this.tagLoading = true;
    if (!tag) return;

    tag = tag.trim();
    if (!tag || this.isSelected(tag)) return;
    console.log('Adding tag:', tag);
    this.httpRequestService
      .request('post', 'current-affairs/add-tags', { tag })
      .subscribe(
        (res: any) => {
          console.log(res);
          const newTag = res.data.name;
          this.tagLoading = false;
          this.listOfTags = [{ name: newTag }, ...this.listOfTags];
          const updatedTags = [...this.tags, newTag];
          this.addUpdateCurrentAffairForm.get('tags')?.setValue(updatedTags);

          this.addUpdateCurrentAffairForm.get('tags')?.markAsDirty();
          input.value = '';

          this.notificationService.success('', 'Tag added successfully');
        },
        () => {
          this.tagLoading = false;
          this.notificationService.error('', 'Failed to add tag');
        },
      );
  }

  private resetTagDropdown(): void {
    this.pageIndex = 1;
    this.tagSearch = '';
    this.listOfTags = [];
    this.getAllTags(0);
  }

  /* Submit subject form */
  submit(): void {
    if (!this.addUpdateCurrentAffairForm.valid) {
      this.markFormGroupTouched(this.addUpdateCurrentAffairForm);
    } else {
      if (this.idForUpdate) {
        this.addOrUpdateCurrentAffairs(
          'put',
          `current-affairs/${this.idForUpdate}`,
          'Current Affair Successfully Updated',
        );
      } else {
        this.addOrUpdateCurrentAffairs(
          'post',
          'current-affairs',
          'Current Affair Added Successfully ',
        );
      }
    }
  }

  /* Add Or Edit Subject */
  addOrUpdateCurrentAffairs(
    requestMethod: string,
    requestURL: string,
    successMessage: string,
  ): void {
    this.buttonLoading = true;
    const finalData: CurrentAffair = this.addUpdateCurrentAffairForm.value;
    this.httpRequestService
      .request(requestMethod, requestURL, finalData)
      .subscribe(
        (result: any) => {
          this.notificationService.success('', successMessage);
          if (this.fromReportContent) {
            this.router.navigate(['/main/report-contents']);
          } else {
            this.router.navigate(['/main/current-affairs'], {
              queryParams: { index: this.tabIndex },
            });
          }
          this.buttonLoading = false;
        },
        (error: any) => {
          if (error.error.errors) {
            const allErrors: string[] = Object.values(error.error.errors);
            for (const err of allErrors) {
              this.notificationService.error('', err);
            }
          } else {
            this.notificationService.error('', error.error.message);
          }
          this.buttonLoading = false;
        },
      );
  }

  // image Upload
  UploadImageFile(
    info: { file: NzUploadFile },
    FormControl: string,
    index: number,
  ) {
    switch (info.file.status) {
      case 'uploading':
        this.imageLoading = true;
        break;
      case 'done':
        this.imageLoading = false;
        this.addUpdateCurrentAffairForm.patchValue({
          image: info.file.response.data.path,
        });
        break;
      case 'error':
        this.msg.error('Network error');
        this.imageLoading = false;
        break;
    }
  }

  beforeRelatedMediaUpload = (
    file: NzUploadFile,
    fileList: NzUploadFile[],
  ): Observable<any> => {
    return new Observable((observer: Observer<boolean>) => {
      const isImage =
        file.type === 'image/jpg' ||
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/JPG' ||
        file.type === 'image/JPEG' ||
        file.type === 'image/PNG';
      if (!isImage) {
        this.msg.error('You can only upload image file!');
        observer.complete();
        return;
      }
      const isLt3M = file.size ? file.size / 1024 / 1024 < 3 : false;
      if (!isLt3M) {
        this.msg.error('Image must smaller than 3MB!');
        observer.complete();
        return;
      }
      observer.next(isImage && isLt3M);
      observer.complete();
    });
  };
  removeImage(path: string): void {
    let params: any;
    params = { path: path };
    this.addUpdateCurrentAffairForm.patchValue({
      image: null,
    });
    this.httpRequestService
      .request('post', 'media/delete-media', params)
      .subscribe((result: any) => {
        if (result) {
          this.notificationService.success('', 'Image Deleted Successfully');
        }
      });
  }
  searchExamCategoryForDropdown(event: any): void {
    this.searchExamCategory.next(event);
  }

  /* Make All Form Controls Dirty */
  private markFormGroupTouched(formGroup: FormGroup): void {
    for (const i in formGroup.controls) {
      if (formGroup.controls.hasOwnProperty(i)) {
        formGroup.controls[i].markAsDirty();
        formGroup.controls[i].updateValueAndValidity();
      }
    }
  }
}
